export default __webpack_public_path__ + "static/media/Flat_Green.b477d5e8.png";